import React, { useEffect, useState } from "react";
import { profile } from "../../containers/assets";
import FilterList from "../Home/ExploreTimeLine/FilterList";
import Header from "../Common/Header/Header";
import Footer from "../Common/Footer/Footer";
import Faq from "../Faq/Faq";
import { Dropdown, Spinner } from "react-bootstrap";
import EditPopup from "../Common/Popup/EditPopup";
import { updateProfile, getProfile } from "../../slice/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import TransactionModal from "../Common/TransactionModal";
import { apiConstants } from "../../constants/api.constants";
import axios from "axios";
import ReactPaginate from "react-paginate";

const Profile = () => {
  const [profileDetails, setProfileDetails] = useState();
  const [show, setShow] = useState(false);
  const [sessionData, setSessionData] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const navigate = useNavigate();

  const [collections, setCollectionData] = useState('')
  const [pageNo, setPageNumber] = useState(0)
  const [search, setSearch] = useState('')

  const url =
    process.env.REACT_APP_BACKEND_URL + process.env.REACT_APP_BASE_API;
  const [showPopup, setShowPopup] = useState(false);

  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => {
    return { profileData: state.user };
  });

  console.log(profileData);
  useEffect(() => {
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    if (
      profileData &&
      profileData.value != undefined &&
      profileData.value != ""
    ) {
      setProfileDetails(profileData.value.user);
    }
  }, [profileData]);

  useEffect(async () => {
    let obj = {
      search: "",
      offset: pageNo,
      creator: sessionData.address
    }
    let collectionList = await axios.post(`${url + apiConstants.GET_ALL_COLLECTIONS_BY_CREATOR}?search=${search}`, obj)
    setCollectionData(collectionList.data.collections)
    setPageNumber(collectionList.data.pages)
  }, []);

  console.log(profileDetails);
  useEffect(async () => {
    let obj = {
      offset: pageNo,
      creator: sessionData.address

    };
    let collectionList = await axios.post(`${url + apiConstants.GET_ALL_COLLECTIONS_BY_CREATOR}?search=${search}`, obj)
    setCollectionData(collectionList.data.collections)
    setPageNumber(collectionList.data.pages)
  }, [search])

  const addDefaultSrc = (ev) => {
    console.log(ev);
    ev.target.src = profile;
  };

  const handlePageClick = async (pageno) => {
    let obj = {
      offset: pageno.selected,
      creator: sessionData.address

    };
    let collectionList = await axios.post(`${url + apiConstants.GET_ALL_COLLECTIONS_BY_CREATOR}?search=${search}`, obj)
    setCollectionData(collectionList.data.collections)
    setPageNumber(collectionList.data.pages)
  };

  console.log(profileDetails);
  // if(!profileDetails) return <></>

  return (
    <>
      <Header />
      <section className="page-banner">
        <div className="container">
          <h2>Profile</h2>
          <ul className="bredcrumb">
            <li>
              <a href="/">Home</a>
            </li>
            <li>Profile</li>
          </ul>
        </div>
      </section>

      <div className="shadow p-3 mb-5 bg-white rounded">
        {/* kyc Status display here ... */}
      </div>
      <section className="sec explore-sec">
        <div className="container">
          <div className="profile-row">
            <div className="profile-col-left">
              <div className="profile-img-l">
                <img
                  onError={addDefaultSrc}
                  src={profileDetails ? profileDetails.profile_image : ""}
                  width="300"
                  height="200"
                  alt=""
                />
              </div>
              <div className="profile-detail-l">
                <h4>
                  {profileDetails && profileDetails.name
                    ? profileDetails.name
                    : ""}{" "}
                  <span>
                    <img src="images/check-icon-b.png" alt="" />
                  </span>
                </h4>
                <p className="prof-seb">{sessionData.address}</p>
                <p>
                  Bio: <br />
                  {profileDetails && profileDetails.description
                    ? profileDetails.description
                    : ""}{" "}
                </p>
                {/* <p className="prof-btn-group">
                  <Link to="/upload-kyc" className="prof-btn m-2">
                    {" "}
                    Upload KYC{" "}
                  </Link>
                </p> */}
              </div>
            </div>
            <div class="profile-col-right">
              {/* <div class="prof-btn-group"> */}
              <button
                className="btn custom-btn wallet-btn m-2"
                onClick={() => {
                  setShow(true);
                }}
              >
                Edit
              </button>
              {/* </div> */}
              <div class="footer-right">
                {profileDetails?.social_media.twitter && profileDetails?.social_media.twitter != "" ? (
                  <a
                    href={profileDetails?.social_media.twitter}
                    target="_blank"
                    class="social-4"
                  >
                    <i class="fab fa-twitter"></i>
                  </a>
                ) : (
                  <></>
                )}
                {profileDetails?.social_media.facebook && profileDetails?.social_media.facebook != "" ? (
                  <a
                    href={profileDetails?.social_media.facebook}
                    target="_blank"
                    class="social-4"
                  >
                    <i class="fab fa-facebook"></i>
                  </a>
                ) : (
                  <></>
                )}
                {profileDetails?.social_media.instagram &&
                profileDetails?.social_media.instagram != "" ? (
                  <a
                    href={profileDetails?.social_media.instagram}
                    target="_blank"
                    class="social-4"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                ) : (
                  <></>
                )}
                {profileDetails?.social_media.linkedin && profileDetails?.social_media.linkedin != "" ? (
                  <a
                    href={profileDetails?.social_media.linkedin}
                    target="_blank"
                    class="social-4"
                  >
                    <i class="fab fa-linkedin"></i>
                  </a>
                ) : (
                  <></>
                )}
                {profileDetails?.social_media.youtube && profileDetails?.social_media.youtube != "" ? (
                  <a
                    href={profileDetails?.social_media.youtube}
                    target="_blank"
                    class="social-4"
                  >
                    <i class="fab fa-youtube"></i>
                  </a>
                ) : (
                  <></>
                )}
                {profileDetails?.social_media.discord && profileDetails?.social_media.discord != "" ? (
                  <a
                    href={profileDetails?.social_media.discord}
                    target="_blank"
                    class="social-4"
                  >
                    <i class="fab fa-discord"></i>
                  </a>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          {/* <FilterList /> */}
          {
        collections && collections.length ? <section className="sec explore-sec">
          <div className="container">
            {" "}
            {/* <div className="row">
            <div className="col-md-6 text-secondary">
              {itemData?.value.items.length} items
            </div>
          </div> */}
          </div>
          <div className="container">
            {/* <div className="d-right">
            <div className="filter-form">
              <div className="filter-form-feild"></div>
              <div className="filter-form-feild">
                <input
                  type="text"
                  name="search"
                  className="form-control"
                  placeholder="Search"
                  // onChange={handleSearch}
                  onChange={(e) => setSearch(e.target.value)}

                />
                <button type="button">
                  <i className="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div> */}
            <div className="item-row">
              <div className="row">
                {collections && collections.length > 0 ? (
                  collections.map((x, index) => {
                    return (
                      <div
                        className="col-sm-6 col-md-6 col-lg-6 col-xl-4"
                        key={index}
                      >
                        <div className="trending-cat-col">
                          <div className="trending-cat-img">
                            <img
                              onError={addDefaultSrc}
                              src={x.logo_image ? x.logo_image : x.logo_image}
                              alt=""
                              onClick={() =>
                                navigate(
                                  `/explore-collection-details/${x._id}`
                                )
                              }
                            />
                          </div>
                          <div className="trending-cat-det">
                            <div className="det-top">
                              <div
                                className="det-top-left"
                                onClick={() =>
                                  navigate(`/collectionDetails/${x._id}`)
                                }
                              >
                                <span className="pro-name">
                                  {x && x.name
                                    ? x.name.charAt(0).toUpperCase() +
                                    x.name.slice(1)
                                    : ""}
                                </span>
                              </div>

                              {/* <div className="det-top-right">
                              {x.deployed ? (
                                <span style={{ color: "green" }}>Deployed</span>
                              ) : (
                                <div onClick={() => handleDeploy(x._id)}>
                                  {" "}
                                  <button class="btn" style={{ color: "red" }}>
                                    Deployed
                                  </button>{" "}
                                </div>
                              )}
                            </div> */}
                            </div>
                            <div className="text-center">
                              <Link
                                to={`/collectionDetails/${x._id}`}
                                className="btn custom-btn wallet-btn"
                              >
                                Details
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="d-flex justify-content-center">
                    Record Not found
                  </div>
                )}
              </div>
              <div className="d-center">
                <ReactPaginate
                  nextLabel="next >"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={pageNo}
                  previousLabel="< previous"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  renderOnZeroPageCount={null}
                />
              </div>
            </div>
          </div>
        </section> : ""
      }

        </div>
      </section>
      {/* <TransactionModal /> */}

      <Footer />

      {/* {isEdit ? ( */}
      <EditPopup
        title="Edit Profile"
        profileDetails={profileDetails}
        size="lg"
        show={show}
        setShow={setShow}
      />
    </>
  );
};

export default Profile;
